export const complimentaryColours = [
	// [ROME-4699] New version.
	'#FF5733',
	'#33C1FF',
	'#8D33FF',
	'#33FF57',
	'#FF33A6',
	'#33FFEC',
	'#3342FF',
	'#FFA833',
	'#D133FF',
	'#A52A2A',
	'#FFD700',
	'#808000',
	'#008080',

	/*'#FF5733',
	'#33C1FF',
	'#8D33FF',
	'#33FF57',
	'#FF33A6',
	'#33FFEC',
	'#FFD133',
	'#3342FF',
	'#FF3333',
	'#33FF8A',
	'#FF33FF',
	'#33FFF6',
	'#FFA833',
	'#337BFF',
	'#FF333D',
	'#33FF4A',
	'#D133FF',
	'#33FFDA',
	'#FFBB33',
	'#3366FF',*/
];

/**
 * Retrieve a complimentary colour tied to an index order in a list.
 *
 * Picks a random colour if no index is provided.
 *
 * @param index Any specific index.
 * @returns The appropriate colour (fails over to first colour).
 */
export const getComplimentaryColour = (index?: number) => {
	const indexToUse = index || Math.round(Math.random() * complimentaryColours.length);

	return (
		complimentaryColours[indexToUse % complimentaryColours.length] || complimentaryColours[0]!
	);
};

/**
 * Convert a string hex code for a colour into it's number value.
 *
 * @param value The colour's hex code.
 * @returns The corresponding number value, if valid.
 */
export const hexColourToNumber = (value?: string) => {
	if (!value) return undefined;

	const cleaned = value.trim();
	const stripped = cleaned.startsWith('#') ? cleaned.substring(1) : cleaned;
	const parsedColor = parseInt(stripped, 16);
	return isNaN(parsedColor) ? undefined : parsedColor;
};
